import { render, staticRenderFns } from "./mg-draggable.vue?vue&type=template&id=31b0da07&scoped=true"
import script from "./mg-draggable.vue?vue&type=script&lang=js"
export * from "./mg-draggable.vue?vue&type=script&lang=js"
import style0 from "./mg-draggable.vue?vue&type=style&index=0&id=31b0da07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0da07",
  null
  
)

export default component.exports